import {
    SAVE_EFFORT_SUCCESS,
    UPDATE_EFFORT_SUCCESS,
    UPDATE_CATCH_SUCCESS,
    SET_ERROR
} from './actionTypes';

export const saveEffort = (response , client_id) => {
    console.log('saveEffortTrip',response);
    if(!response){
        console.error('saveEffortTrip','no effort data provided');
        return {
            type: SET_ERROR,
            error: 'no effort data provided'
        };
    }
    if(!client_id){
        console.error('no client id provided');
        return {
            type: SET_ERROR,
            error: 'no client id provided'
        };
    }
    return {
        type: SAVE_EFFORT_SUCCESS,
        meta: response,
        client_id: client_id
    };
}
export const updateEffort = (response , client_id) => {
    console.log('updateEffortTrip',response);
    if(!response){
        console.error('updateEffortTrip','no effort data provided');
        return {
            type: SET_ERROR,
            error: 'no effort data provided'
        };
    }
    if(!client_id){
        console.error('no client id provided');
        return {
            type: SET_ERROR,
            error: 'no client id provided'
        };
    }
    return {
        type: UPDATE_EFFORT_SUCCESS,
        meta: response,
        client_id: client_id
    };
}
export const updateCatch = (response , client_id, effort_id , catch_id) => {
    console.log('updateCatch',response);
    if(!response || Object.keys(response).length === 0){
        console.error('updateCatch','no catch data provided');
        return {
            type: SET_ERROR,
            error: 'no catch data provided'
        };
    }
    if(!client_id){
        console.error('updateCatch','no client id provided');
        return {
            type: SET_ERROR,
            error: 'no client id provided'
        };
    }
    if(effort_id === '' || effort_id === undefined){
        console.error('updateCatch','no effort id provided');
        return {
            type: SET_ERROR,
            error: 'no effort id provided'
        };
    }
    if(catch_id === '' || catch_id === undefined){
        console.error('updateCatch','no catch id provided');
        return {
            type: SET_ERROR,
            error: 'no catch id provided'
        };
    }
    return {
        type: UPDATE_CATCH_SUCCESS,
        meta: response,
        client_id: client_id,
        effort_id:effort_id,
        catch_id:catch_id
    };
}
